const { Keywords } = require('../core/keywords');

/**
 * Supported Escape Characters:
 * \n - Newline
 * \t - Tab
 * \r - Carriage Return
 * \" - Double Quote
 * \' - Single Quote
 * \\ - Backslash
 */

module.exports = {
    [Keywords.PROGRAM_START]: 'hi {{name}}',
    [Keywords.PROGRAM_END]: 'bye {{name}}',
    [Keywords.PRINT]: 'tell {{name}}',
    [Keywords.VARIABLE]: '{{name}} this is',
    [Keywords.UNTIL]: 'until {{name}}',
    [Keywords.IF]: 'if {{name}}',
    [Keywords.ELSE]: 'otherwise {{name}}',
    [Keywords.FOR]: 'loop {{name}}',
    [Keywords.BREAK]: 'break',
    [Keywords.CONTINUE]: 'continue',
    [Keywords.TRUE]: 'true',
    [Keywords.FALSE]: 'false',
    [Keywords.AND]: 'and',
    [Keywords.OR]: 'or',
    [Keywords.LENGTH]: 'length',
    [Keywords.INPUT]: 'ask {{name}}'
};
